import { Button } from "@/components/ui/button";
import { ReactNode } from "react";

interface HeaderProps {
  title: string;
  onRefresh?: () => void;
  actionComponent?: ReactNode;
}

const Header = ({ title, onRefresh, actionComponent }: HeaderProps) => {
  return (
    <header className="bg-white shadow-sm z-10">
      <div className="px-6 py-3 flex items-center justify-between">
        <div className="flex items-center">
          <h2 className="text-lg font-medium">{title}</h2>
        </div>
        <div className="flex items-center space-x-4">
          {actionComponent}
          {onRefresh && (
            <Button
              variant="default"
              className="flex items-center px-3 py-1 text-sm border border-[#0078D4] bg-[#0078D4] text-white rounded hover:bg-[#2B88D8]"
              onClick={onRefresh}
            >
              <span className="material-icons text-sm mr-1">refresh</span>
              Refresh
            </Button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
